import {NgModule} from '@angular/core';

import {ImageSliderComponent} from './image-slider.component';
import {IonicModule} from 'ionic-angular';
import {HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {HammerSliderConfig} from './hammer.config';

/**
 * Module for the Image Slider
 */
@NgModule({
  declarations: [ImageSliderComponent],
  entryComponents: [ImageSliderComponent],
  exports: [ImageSliderComponent],
  imports: [IonicModule],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerSliderConfig,
    },
  ],
})
export class SliderModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/image/slider/image-slider.module.ts